import axios from 'axios';
import { ManualFeedsUser } from '../types/manual-feeds-user.type';

// GET
// Returns list of users.
// ​/ewosapi​/v1​/feeds/manual/company/{globalCompanyId}​/user
export const getManualFeedsUsers = async (globalCompanyId: string): Promise<ManualFeedsUser[]> => {
  const res = await axios.get<ManualFeedsUser[]>(`/ewosapi/v1/feeds/manual/company/${globalCompanyId}/user`);
  return res.data;
};
